import { InvoiceDocument } from '../types/invoice'

// Mock invoice list for sidebar - updated to match Invoice type
export const mockInvoices = [
  {
    id: '1',
    documentType: 'PO Invoice',
    vendor: 'Dell Australia',
    documentNo: 'INV-2024-0123',
    documentDate: '25/01/2024',
    dueDate: '24/02/2024',
    receivedDate: '26/01/2024',
    poNo: 'PO00789',
    amount: '$96,000.00',
    status: 'Pending Review' as const,
    team: 'AP Team',
    timestamp: '2 hours ago',
    matchingType: '3-way' as const,
    lockedBy: 'Sarah Chen',
    lockedAt: '2024-01-26T14:30:00Z',
  },
  {
    id: '2',
    documentType: 'PO Invoice',
    vendor: 'Office Furniture Co',
    documentNo: 'INV-2024-0124',
    documentDate: '26/01/2024',
    dueDate: '25/02/2024',
    receivedDate: '27/01/2024',
    poNo: 'PO00856',
    amount: '$9,000.00',
    status: 'Pending Approval' as const,
    team: 'AP Team',
    timestamp: '3 hours ago',
    matchingType: '3-way' as const,
  },
  {
    id: '3',
    documentType: 'Credit Note',
    vendor: 'Tech Supplies Ltd',
    documentNo: 'CN-2024-0045',
    documentDate: '27/01/2024',
    dueDate: '26/02/2024',
    receivedDate: '28/01/2024',
    poNo: '',
    amount: '-$3,000.00',
    status: 'Draft' as const,
    team: 'AP Team',
    timestamp: '4 hours ago',
    matchingType: 'non-po' as const,
  },
  {
    id: '4',
    documentType: 'Non-PO Invoice',
    vendor: 'Office Supplies Co',
    documentNo: 'INV-2024-0125',
    documentDate: '28/01/2024',
    dueDate: '27/02/2024',
    receivedDate: '29/01/2024',
    poNo: '',
    amount: '$4,500.00',
    status: 'Pending Coding' as const,
    team: 'AP Team',
    timestamp: '5 hours ago',
    matchingType: 'non-po' as const,
    lockedBy: 'Current User',
    lockedAt: '2024-01-29T10:15:00Z',
  },
  {
    id: '5',
    documentType: 'Non-PO Invoice',
    vendor: 'Tech Equipment Ltd',
    documentNo: 'INV-2024-0126',
    documentDate: '28/01/2024',
    dueDate: '28/02/2024',
    receivedDate: '30/01/2024',
    poNo: '',
    amount: '$15,000.00',
    status: 'Approved' as const,
    team: 'Finance Team',
    timestamp: '6 hours ago',
    matchingType: 'non-po' as const,
    lockedBy: 'Mike Johnson',
    lockedAt: '2024-01-30T09:00:00Z',
  },
  {
    id: '6',
    documentType: 'Credit Note',
    vendor: 'Dell Australia',
    documentNo: 'CN-2024-0046',
    documentDate: '29/01/2024',
    dueDate: '01/03/2024',
    receivedDate: '31/01/2024',
    poNo: '',
    amount: '-$2,500.00',
    status: 'Validating' as const,
    team: 'AP Team',
    timestamp: '1 day ago',
    matchingType: 'non-po' as const,
  },
  {
    id: '7',
    documentType: 'PO Invoice',
    vendor: 'Office Furniture Co',
    documentNo: 'INV-2024-0127',
    documentDate: '30/01/2024',
    dueDate: '02/03/2024',
    receivedDate: '01/02/2024',
    poNo: 'PO00912',
    amount: '$8,000.00',
    status: 'Match Success' as const,
    team: 'AP Team',
    timestamp: '1 day ago',
    matchingType: '2-way' as const,
  },
  {
    id: '8',
    documentType: 'PO Invoice',
    vendor: 'Dell Australia',
    documentNo: 'INV-2024-0128',
    documentDate: '31/01/2024',
    dueDate: '03/03/2024',
    receivedDate: '02/02/2024',
    poNo: 'PO00789',
    amount: '$96,000.00',
    status: 'Ready for Payment' as const,
    team: 'Finance Team',
    timestamp: '2 days ago',
    tag: 'Multi-GR Example',
    matchingType: '3-way' as const,
  },
]

// Mock invoice details - now returns function to generate details from document
export const getInvoiceDetails = (document: InvoiceDocument) => ({
  entity: 'Abbott Australasia Pty Ltd',
  site: 'Level 4, 32-34 Lord Street',
  supplierCode: document.supplier.substring(0, 6).toUpperCase(),
  vendorName: document.supplier,
  vendorTaxNo: document.supplierABN || 'N/A',
  email: `accounts@${document.supplier.toLowerCase().replace(/\s+/g, '')}.com`,
  phoneNumber: '(02) 9384 3000',
  address: 'Level 4, 32-34 Lord Street',
  city: 'Botany',
  state: 'NSW',
  country: 'Australia',
  postcode: '2019',
  vendorBankCheck: true,
  // Bank details
  bankName: 'Commonwealth Bank of Australia',
  bankAccountName: document.supplier,
  bankAccountNumber: '1234 5678',
  bankBSB: '062-000',
  bankSwiftCode: 'CTBAAU2S',
  bankIBAN: 'AU21 0620 0012 3456 7890',
  // Additional vendor details
  vendorCategory: 'Approved Supplier',
  paymentTerms: 'Net 30 days',
  registrationDate: '15/03/2020',
  lastVerifiedDate: '10/01/2024',
  // ABR Lookup data (for Australian vendors with ABN)
  abrStatus: 'Active',
  abrLastUpdatedDate: '26/09/2025',
  abrStatusEffectiveFrom: '01/04/2000',
  asicRegistration: '000228231',
  abrEntityName: document.supplier.toUpperCase(),
  abrEntityType: 'Australian Public Company',
  gstEffectiveFrom: '01/07/2000',
  isDeductibleGiftRecipient: 'No',
  mainBusinessLocationPostcode: '2019',
  mainBusinessLocationStateCode: 'NSW',
})

// Legacy export for backward compatibility
export const mockInvoiceDetails = {
  entity: 'Abbott Australasia Pty Ltd',
  site: 'Level 4, 32-34 Lord Street',
  supplierCode: 'OFFICE',
  vendorName: 'Office Supplies Co',
  vendorTaxNo: '12 345 678 901',
  email: 'accounts@officesupplies.com.au',
  phoneNumber: '(02) 9876 5432',
  address: '123 Business St',
  city: 'Sydney',
  state: 'NSW',
  country: 'Australia',
  postcode: '2000',
  vendorBankCheck: true,
  // Bank details
  bankName: 'Commonwealth Bank of Australia',
  bankAccountName: 'Office Supplies Co',
  bankAccountNumber: '1234 5678',
  bankBSB: '062-000',
  bankSwiftCode: 'CTBAAU2S',
  bankIBAN: 'AU21 0620 0012 3456 7890',
  // Additional vendor details
  vendorCategory: 'Approved Supplier',
  paymentTerms: 'Net 30 days',
  registrationDate: '15/03/2020',
  lastVerifiedDate: '10/01/2024',
  // ABR Lookup data
  abrStatus: 'Active',
  abrLastUpdatedDate: '26/09/2025',
  abrStatusEffectiveFrom: '01/04/2000',
  asicRegistration: '000228231',
  abrEntityName: 'OFFICE SUPPLIES CO',
  abrEntityType: 'Australian Public Company',
  gstEffectiveFrom: '01/07/2000',
  isDeductibleGiftRecipient: 'No',
  mainBusinessLocationPostcode: '2000',
  mainBusinessLocationStateCode: 'NSW',
}

// Mock vendor details
export const mockOfficeSuppliesVendor = {
  name: 'Office Supplies Co',
  abn: '12 345 678 901',
  address: '123 Business St, Sydney NSW 2000',
  phone: '+61 2 9876 5432',
  email: 'accounts@officesupplies.com.au',
}

export const mockTechEquipmentVendor = {
  name: 'Tech Equipment Ltd',
  abn: '98 765 432 109',
  address: '456 Tech Park, Melbourne VIC 3000',
  phone: '+61 3 8765 4321',
  email: 'invoices@techequipment.com.au',
}

// Invoice #1 - Dell Laptops (3-Way Match - Single Line Item)
// CORRECTED: Invoice line items are DR (Debit - expenses/assets)
export const mockInvoice1Document: InvoiceDocument = {
  id: '1',
  invoiceNumber: 'INV-2024-0123',
  supplier: 'Dell Australia',
  supplierABN: '61 008 714 849',
  invoiceDate: '25/01/2024',
  dueDate: '24/02/2024',
  receivedDate: '26/01/2024',
  currency: 'AUD',
  subtotal: 133090.91,
  taxAmt: 13309.09,
  total: 146400.0,
  status: 'draft',
  type: 'standard',
  matchingType: '3-way',
  poNumber: 'PO00789',
  lineItems: [
    {
      id: 'line-1',
      itemCode: 'LAT-5420-001',
      description:
        'Dell Latitude 5420 Laptop - 14" FHD, i5-1145G7, 16GB RAM, 256GB SSD',
      quantity: 80,
      unitPrice: 1090.91,
      subtotal: 87272.73,
      taxCode: 'I',
      taxAmt: 8727.27,
      total: 96000.0,
      type: 'DR',
      glCode: '6200-1100-0000',
      notes: 'Bulk order for IT department',
      poMatch: {
        poNumber: 'PO00789',
        poLineNumber: 10,
        poLineDescription: 'Dell Latitude 5420 Laptop - 14" FHD',
        poQuantity: 100,
        poUnitPrice: 1090.91,
        matchedQuantity: 80,
        remainingQuantity: 20,
        matchedAmount: 87272.73,
        poDate: '02/01/2024',
        supplier: 'Dell Australia',
      },
      grMatches: [
        {
          grNumber: 'GR-2024-0123',
          grDate: '05/01/2024',
          grQuantity: 30,
          allocatedQuantity: 30,
          grLineNumber: 1,
          poNumber: 'PO00789',
          poLineNumber: 10,
        },
        {
          grNumber: 'GR-2024-0145',
          grDate: '12/01/2024',
          grQuantity: 50,
          allocatedQuantity: 50,
          grLineNumber: 1,
          poNumber: 'PO00789',
          poLineNumber: 10,
        },
      ],
    },
    {
      id: 'line-2',
      itemCode: 'MON-27-001',
      description: 'Dell 27" UltraSharp Monitor - 4K, USB-C, Height Adjustable',
      quantity: 50,
      unitPrice: 545.45,
      subtotal: 27272.73,
      taxCode: 'I',
      taxAmt: 2727.27,
      total: 30000.0,
      type: 'DR',
      glCode: '6200-1100-0000',
      notes: 'Monitors for new office setup',
      poMatch: {
        poNumber: 'PO00789',
        poLineNumber: 20,
        poLineDescription: 'Dell 27" UltraSharp Monitor - 4K',
        poQuantity: 50,
        poUnitPrice: 545.45,
        matchedQuantity: 50,
        remainingQuantity: 0,
        matchedAmount: 27272.73,
        poDate: '02/01/2024',
        supplier: 'Dell Australia',
      },
      grMatches: [
        {
          grNumber: 'GR-2024-0156',
          grDate: '15/01/2024',
          grQuantity: 50,
          allocatedQuantity: 50,
          grLineNumber: 1,
          poNumber: 'PO00789',
          poLineNumber: 20,
        },
      ],
    },
    {
      id: 'line-3',
      itemCode: 'KB-MOUSE-001',
      description: 'Dell Wireless Keyboard and Mouse Combo',
      quantity: 100,
      unitPrice: 90.91,
      subtotal: 9090.91,
      taxCode: 'I',
      taxAmt: 909.09,
      total: 10000.0,
      type: 'DR',
      glCode: '6200-1100-0000',
      notes: 'Accessories for workstations',
      poMatch: {
        poNumber: 'PO00789',
        poLineNumber: 30,
        poLineDescription: 'Dell Wireless Keyboard and Mouse Combo',
        poQuantity: 100,
        poUnitPrice: 90.91,
        matchedQuantity: 100,
        remainingQuantity: 0,
        matchedAmount: 9090.91,
        poDate: '02/01/2024',
        supplier: 'Dell Australia',
      },
      grMatches: [
        {
          grNumber: 'GR-2024-0167',
          grDate: '18/01/2024',
          grQuantity: 100,
          allocatedQuantity: 100,
          grLineNumber: 1,
          poNumber: 'PO00789',
          poLineNumber: 30,
        },
      ],
    },
  ],
  notes: 'Payment terms: Net 30 days',
  attachments: ['invoice-123.pdf'],
  createdAt: '2024-01-25T09:30:00Z',
  updatedAt: '2024-01-25T14:45:00Z',
}

// Invoice #2 - Office Furniture (3-Way Match - Multiple Line Items)
// CORRECTED: Invoice line items are DR
export const mockInvoice2Document: InvoiceDocument = {
  id: '2',
  invoiceNumber: 'INV-2024-0124',
  supplier: 'Office Furniture Co',
  supplierABN: '52 123 456 789',
  invoiceDate: '26/01/2024',
  dueDate: '25/02/2024',
  receivedDate: '27/01/2024',
  currency: 'AUD',
  subtotal: 18181.82,
  taxAmt: 1818.18,
  total: 20000.0,
  status: 'pending_approval',
  type: 'standard',
  matchingType: '3-way',
  poNumber: 'PO00856',
  lineItems: [
    {
      id: 'line-1',
      itemCode: 'CHAIR-ERG-001',
      description:
        'Ergonomic Mesh Office Chair - Adjustable Arms, Lumbar Support',
      quantity: 25,
      unitPrice: 327.27,
      subtotal: 8181.82,
      taxCode: 'I',
      taxAmt: 818.18,
      total: 9000.0,
      type: 'DR',
      glCode: '6300-1200-0000',
      poMatch: {
        poNumber: 'PO00856',
        poLineNumber: 1,
        poLineDescription: 'Office Chairs - Ergonomic Mesh',
        poQuantity: 25,
        poUnitPrice: 327.27,
        matchedQuantity: 25,
        remainingQuantity: 0,
        matchedAmount: 8181.82,
        poDate: '15/01/2024',
        supplier: 'Office Furniture Co',
      },
      grMatches: [
        {
          grNumber: 'GR-2024-0189',
          grDate: '22/01/2024',
          grQuantity: 25,
          allocatedQuantity: 25,
          grLineNumber: 1,
          poNumber: 'PO00856',
          poLineNumber: 1,
        },
      ],
    },
    {
      id: 'line-2',
      itemCode: 'DESK-STD-001',
      description: 'Standing Desk - Electric Height Adjustable, 1600mm x 800mm',
      quantity: 15,
      unitPrice: 363.64,
      subtotal: 5454.55,
      taxCode: 'I',
      taxAmt: 545.45,
      total: 6000.0,
      type: 'DR',
      glCode: '6300-1200-0000',
      poMatch: {
        poNumber: 'PO00856',
        poLineNumber: 2,
        poLineDescription: 'Standing Desk - Electric Height Adjustable',
        poQuantity: 15,
        poUnitPrice: 363.64,
        matchedQuantity: 15,
        remainingQuantity: 0,
        matchedAmount: 5454.55,
        poDate: '15/01/2024',
        supplier: 'Office Furniture Co',
      },
      grMatches: [
        {
          grNumber: 'GR-2024-0189',
          grDate: '22/01/2024',
          grQuantity: 15,
          allocatedQuantity: 15,
          grLineNumber: 2,
          poNumber: 'PO00856',
          poLineNumber: 2,
        },
      ],
    },
    {
      id: 'line-3',
      itemCode: 'CABINET-FILE-001',
      description: 'Mobile Filing Cabinet - 3 Drawer, Lockable',
      quantity: 20,
      unitPrice: 227.27,
      subtotal: 4545.45,
      taxCode: 'I',
      taxAmt: 454.55,
      total: 5000.0,
      type: 'DR',
      glCode: '6300-1200-0000',
      poMatch: {
        poNumber: 'PO00856',
        poLineNumber: 3,
        poLineDescription: 'Mobile Filing Cabinet - 3 Drawer',
        poQuantity: 20,
        poUnitPrice: 227.27,
        matchedQuantity: 20,
        remainingQuantity: 0,
        matchedAmount: 4545.45,
        poDate: '15/01/2024',
        supplier: 'Office Furniture Co',
      },
      grMatches: [
        {
          grNumber: 'GR-2024-0190',
          grDate: '23/01/2024',
          grQuantity: 20,
          allocatedQuantity: 20,
          grLineNumber: 1,
          poNumber: 'PO00856',
          poLineNumber: 3,
        },
      ],
    },
  ],
  createdAt: '2024-01-26T10:15:00Z',
  updatedAt: '2024-01-26T10:15:00Z',
}

// Invoice #3 - Credit Note (Non-PO - Single Line Item)
// CORRECTED: Credit Note line items are CR (Credit - reversing expenses)
export const mockInvoice3Document: InvoiceDocument = {
  id: '3',
  invoiceNumber: 'CN-2024-0045',
  supplier: 'Tech Supplies Ltd',
  supplierABN: '78 987 654 321',
  invoiceDate: '27/01/2024',
  dueDate: '26/02/2024',
  receivedDate: '28/01/2024',
  currency: 'AUD',
  subtotal: -2727.27,
  taxAmt: -272.73,
  total: -3000.0,
  status: 'draft',
  type: 'credit_note',
  matchingType: 'non-po',
  lineItems: [
    {
      id: 'line-1',
      itemCode: 'MON-27-001',
      description: 'Dell 27" Monitor - Returned (Damaged)',
      quantity: 10,
      unitPrice: 272.73,
      subtotal: -2727.27,
      taxCode: 'I',
      taxAmt: -272.73,
      total: -3000.0,
      type: 'CR',
      glCode: '6200-1100-0000',
      notes: 'Credit for damaged monitors returned to supplier',
    },
  ],
  notes: 'Credit note for damaged goods',
  createdAt: '2024-01-27T11:20:00Z',
  updatedAt: '2024-01-27T11:20:00Z',
}

// Invoice #4 - Office Supplies (Non-PO - Multiple Line Items)
// CORRECTED: Invoice line items are DR
// MODIFIED: Added validation errors for testing
export const mockInvoiceDocument: InvoiceDocument = {
  id: '4',
  invoiceNumber: 'INV-2024-0125',
  supplier: 'Office Supplies Co',
  supplierABN: '12 345 678 901',
  invoiceDate: '28/01/2024',
  dueDate: '27/02/2024',
  receivedDate: '29/01/2024',
  currency: 'AUD',
  subtotal: 4090.91,
  taxAmt: 409.09, // INCORRECT: Should be 0 for tax code E, but set to 409.09 to trigger validation error
  total: 4500.0, // INCORRECT: Should be 4090.91, but set to 4500.0 to trigger arithmetic error
  status: 'draft',
  type: 'standard',
  matchingType: 'non-po',
  lineItems: [
    {
      id: 'line-1',
      itemCode: 'PAPER-A4-001',
      description: 'A4 Copy Paper - 80gsm White, 5 Reams',
      quantity: 10,
      unitPrice: 45.45,
      subtotal: 454.55,
      taxCode: 'I', // INCORRECT: Changed from E to I to trigger tax validation error
      taxAmt: 45.45, // INCORRECT: Should be 45.45 for tax code I, but line uses I when it should be E
      total: 500.0,
      type: 'DR',
      glCode: '6400-1300-0000',
    },
    {
      id: 'line-2',
      itemCode: 'PEN-BLUE-001',
      description: 'Ballpoint Pens - Blue, Box of 50',
      quantity: 20,
      unitPrice: 18.18,
      subtotal: 363.64,
      taxCode: 'E',
      taxAmt: 36.36, // INCORRECT: Should be 0 for tax code E, but set to 36.36 to trigger validation error
      total: 400.0,
      type: 'DR',
      glCode: '6400-1300-0000',
    },
    {
      id: 'line-3',
      itemCode: 'NOTE-A5-001',
      description: 'Spiral Notebooks - A5, Ruled, Pack of 10',
      quantity: 15,
      unitPrice: 90.91,
      subtotal: 1363.64,
      taxCode: 'E',
      taxAmt: 136.36, // INCORRECT: Should be 0 for tax code E, but set to 136.36 to trigger validation error
      total: 1500.0,
      type: 'DR',
      glCode: '6400-1300-0000',
    },
    {
      id: 'line-4',
      itemCode: 'FOLDER-001',
      description: 'Manila Folders - A4, Box of 100',
      quantity: 8,
      unitPrice: 136.36,
      subtotal: 1090.91,
      taxCode: 'E',
      taxAmt: 109.09, // INCORRECT: Should be 0 for tax code E, but set to 109.09 to trigger validation error
      total: 1200.0,
      type: 'DR',
      glCode: '6400-1300-0000',
    },
    {
      id: 'line-5',
      itemCode: 'STAPLER-001',
      description: 'Heavy Duty Stapler - 100 Sheet Capacity',
      quantity: 5,
      unitPrice: 163.64,
      subtotal: 818.18,
      taxCode: 'E',
      taxAmt: 81.82, // INCORRECT: Should be 0 for tax code E, but set to 81.82 to trigger validation error
      total: 900.0,
      type: 'DR',
      glCode: '6400-1300-0000',
    },
  ],
  notes: 'Standard office supplies order',
  createdAt: '2024-01-28T10:00:00Z',
  updatedAt: '2024-01-28T10:00:00Z',
}

// Invoice #5 - Tech Equipment (Non-PO - Multiple Line Items)
// CORRECTED: Invoice line items are DR
export const mockInvoice5Document: InvoiceDocument = {
  id: '5',
  invoiceNumber: 'INV-2024-0126',
  supplier: 'Tech Equipment Ltd',
  supplierABN: '98 765 432 109',
  invoiceDate: '28/01/2024',
  dueDate: '28/02/2024',
  receivedDate: '30/01/2024',
  currency: 'AUD',
  subtotal: 13636.36,
  taxAmt: 0.0,
  total: 13636.36,
  status: 'pending_approval',
  type: 'standard',
  matchingType: 'non-po',
  lineItems: [
    {
      id: 'line-1',
      itemCode: 'DOCK-USB-001',
      description: 'USB-C Docking Station - Dual 4K Display Support',
      quantity: 15,
      unitPrice: 272.73,
      subtotal: 4090.91,
      taxCode: 'E',
      taxAmt: 0.0,
      total: 4090.91,
      type: 'DR',
      glCode: '6200-1100-0000',
    },
    {
      id: 'line-2',
      itemCode: 'KB-MECH-001',
      description: 'Mechanical Keyboard - RGB, Cherry MX Brown',
      quantity: 20,
      unitPrice: 136.36,
      subtotal: 2727.27,
      taxCode: 'E',
      taxAmt: 0.0,
      total: 2727.27,
      type: 'DR',
      glCode: '6200-1100-0000',
    },
    {
      id: 'line-3',
      itemCode: 'MOUSE-ERGO-001',
      description: 'Ergonomic Wireless Mouse - Vertical Design',
      quantity: 20,
      unitPrice: 81.82,
      subtotal: 1636.36,
      taxCode: 'E',
      taxAmt: 0.0,
      total: 1636.36,
      type: 'DR',
      glCode: '6200-1100-0000',
    },
    {
      id: 'line-4',
      itemCode: 'HDMI-CABLE-001',
      description: 'HDMI 2.1 Cable - 2m, 8K Support',
      quantity: 30,
      unitPrice: 45.45,
      subtotal: 1363.64,
      taxCode: 'E',
      taxAmt: 0.0,
      total: 1363.64,
      type: 'DR',
      glCode: '6200-1100-0000',
    },
    {
      id: 'line-5',
      itemCode: 'WEBCAM-4K-001',
      description: '4K Webcam - Auto-Focus, Noise Cancelling Mic',
      quantity: 10,
      unitPrice: 381.82,
      subtotal: 3818.18,
      taxCode: 'E',
      taxAmt: 0.0,
      total: 3818.18,
      type: 'DR',
      glCode: '6200-1100-0000',
    },
  ],
  notes: 'Tech equipment for remote workers',
  createdAt: '2024-01-28T14:30:00Z',
  updatedAt: '2024-01-28T14:30:00Z',
}

// Credit Note document (Invoice #6 - Single Line Item)
// CORRECTED: Credit Note line items are CR
export const mockCreditNoteDocument: InvoiceDocument = {
  id: '6',
  invoiceNumber: 'CN-2024-0046',
  supplier: 'Dell Australia',
  supplierABN: '61 008 714 849',
  invoiceDate: '29/01/2024',
  dueDate: '01/03/2024',
  receivedDate: '31/01/2024',
  currency: 'AUD',
  subtotal: -2272.73,
  taxAmt: -227.27,
  total: -2500.0,
  status: 'draft',
  type: 'credit_note',
  matchingType: 'non-po',
  lineItems: [
    {
      id: 'line-1',
      itemCode: 'LAT-5420-001',
      description: 'Dell Latitude 5420 Laptop - Returned (Defective)',
      quantity: 2,
      unitPrice: 1136.36,
      subtotal: -2272.73,
      taxCode: 'I',
      taxAmt: -227.27,
      total: -2500.0,
      type: 'CR',
      glCode: '6200-1100-0000',
      notes: 'Credit for defective units returned to supplier',
    },
  ],
  notes: 'Credit note for defective laptops',
  createdAt: '2024-01-29T09:00:00Z',
  updatedAt: '2024-01-29T09:00:00Z',
}

// 2-Way Matching document (Invoice #7 - Single Line Item)
// CORRECTED: Invoice line items are DR
// MODIFIED: Header amounts don't add up to trigger validation errors
export const mock2WayMatchingDocument: InvoiceDocument = {
  id: '7',
  invoiceNumber: 'INV-2024-0127',
  supplier: 'Office Furniture Co',
  supplierABN: '52 123 456 789',
  invoiceDate: '30/01/2024',
  dueDate: '02/03/2024',
  receivedDate: '01/02/2024',
  currency: 'AUD',
  subtotal: 7500.0, // INCORRECT: Should be 7272.73 to match line items
  taxAmt: 800.0, // INCORRECT: Should be 727.27 to match line items
  total: 8500.0, // INCORRECT: Should be 8000.0 (subtotal + tax doesn't equal total)
  status: 'draft',
  type: 'standard',
  matchingType: '2-way',
  poNumber: 'PO00912',
  lineItems: [
    {
      id: 'line-1',
      itemCode: 'DESK-STD-001',
      description: 'Standard Office Desk - 1400mm x 700mm',
      quantity: 20,
      unitPrice: 363.64,
      subtotal: 7272.73,
      taxCode: 'I',
      taxAmt: 727.27,
      total: 8000.0,
      type: 'DR',
      glCode: '6300-1200-0000',
      poMatch: {
        poNumber: 'PO00912',
        poLineNumber: 1,
        poLineDescription: 'Standard Office Desk - 1400mm x 700mm',
        poQuantity: 20,
        poUnitPrice: 363.64,
        matchedQuantity: 20,
        remainingQuantity: 0,
        matchedAmount: 7272.73,
        poDate: '20/01/2024',
        supplier: 'Office Furniture Co',
      },
    },
  ],
  createdAt: '2024-01-30T11:00:00Z',
  updatedAt: '2024-01-30T11:00:00Z',
}

// 3-Way Matching document (Invoice #8 - Single Line Item with multiple GRs)
// CORRECTED: Invoice line items are DR
export const mock3WayMatchingDocument: InvoiceDocument = {
  id: '8',
  invoiceNumber: 'INV-2024-0128',
  supplier: 'Dell Australia',
  supplierABN: '61 008 714 849',
  invoiceDate: '31/01/2024',
  dueDate: '03/03/2024',
  receivedDate: '02/02/2024',
  currency: 'AUD',
  subtotal: 87272.73,
  taxAmt: 8727.27,
  total: 96000.0,
  status: 'draft',
  type: 'standard',
  matchingType: '3-way',
  poNumber: 'PO00789',
  lineItems: [
    {
      id: 'line-1',
      itemCode: 'LAT-5420-001',
      description:
        'Dell Latitude 5420 Laptop - 14" FHD, i5-1145G7, 16GB RAM, 256GB SSD',
      quantity: 80,
      unitPrice: 1090.91,
      subtotal: 87272.73,
      taxCode: 'I',
      taxAmt: 8727.27,
      total: 96000.0,
      type: 'DR',
      glCode: '6200-1100-0000',
      notes: 'Bulk order for new employee onboarding',
      poMatch: {
        poNumber: 'PO00789',
        poLineNumber: 1,
        poLineDescription: 'Dell Latitude 5420 Laptop - 14" FHD',
        poQuantity: 100,
        poUnitPrice: 1090.91,
        matchedQuantity: 80,
        remainingQuantity: 20,
        matchedAmount: 87272.73,
        poDate: '02/01/2024',
        supplier: 'Dell Australia',
      },
      grMatches: [
        {
          grNumber: 'GR-2024-0123',
          grDate: '05/01/2024',
          grQuantity: 30,
          allocatedQuantity: 30,
          grLineNumber: 1,
          poNumber: 'PO00789',
          poLineNumber: 1,
        },
        {
          grNumber: 'GR-2024-0145',
          grDate: '12/01/2024',
          grQuantity: 50,
          allocatedQuantity: 50,
          grLineNumber: 1,
          poNumber: 'PO00789',
          poLineNumber: 1,
        },
      ],
    },
  ],
  notes: 'Payment terms: Net 30 days',
  attachments: ['invoice-128.pdf'],
  createdAt: '2024-01-31T09:30:00Z',
  updatedAt: '2024-01-31T14:45:00Z',
}
